<template>
  <router-link v-bind="$attrs" :to="to" v-on="$listeners">
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  name: 'ATag',
  props: ['to'],
  inheritAttrs: false
}
</script>



// WEBPACK FOOTER //
// src/components/common/ATag.vue